import { render, staticRenderFns } from "./kiosk-re-header.vue?vue&type=template&id=eb280616&"
import script from "./kiosk-re-header.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports